import {create} from "twrnc";

const twConfig = require("../../tailwind.config.js");
const tw = create(twConfig);

export default tw;